import { ComponentProps, MouseEvent } from 'react';

import {
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
} from 'react-hook-form';

import { FullTextToggleButton as UncontrolledFullTextToggleButton } from '@/components';

type UncontrolledFullTextToggleButtonProps = ComponentProps<
  typeof UncontrolledFullTextToggleButton
>;

type FullTextToggleButtonProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<UncontrolledFullTextToggleButtonProps, 'value' | 'onChange'> & {
  onChange?: UncontrolledFullTextToggleButtonProps['onChange'];
  ControllerProps: Omit<ControllerProps<TFieldValues, TName>, 'render'>;
  valueType?: 'number' | 'string' | 'boolean';
};

export const FullTextToggleButton = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  ControllerProps,
  valueType,
  ...props
}: FullTextToggleButtonProps<TFieldValues, TName>) => {
  return (
    <Controller
      {...ControllerProps}
      render={({ field: { value, disabled, onChange } }) => {
        const correctedTypeValue =
          valueType === 'number' ? parseFloat(value) : value;

        return (
          <UncontrolledFullTextToggleButton
            {...props}
            ToggleButtonGroupProps={{
              ...props.ToggleButtonGroupProps,
              disabled: props.ToggleButtonGroupProps?.disabled || disabled,
            }}
            value={correctedTypeValue}
            onChange={(
              event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
              value: string | number | boolean | null,
            ) => {
              onChange(value);
              props.onChange && props.onChange(event, value);
            }}
          />
        );
      }}
    />
  );
};
